import {Component, Inject, Signal} from '@angular/core';
import {
  CancelIconButtonComponent,
  ConfirmIconButtonComponent,
  DialogHeaderComponent,
  ISelectFormOption,
  SelectElementComponent,
  TDBObject,
} from 'frontier';
import {MAT_DIALOG_DATA, MatDialogActions, MatDialogRef} from '@angular/material/dialog';
import {MatTooltip} from '@angular/material/tooltip';
import {FormControl} from '@angular/forms';
import {toSignal} from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-language-selection-dialog',
  standalone: true,
  imports: [
    CancelIconButtonComponent,
    ConfirmIconButtonComponent,
    DialogHeaderComponent,
    MatDialogActions,
    MatTooltip,
    SelectElementComponent,
  ],
  templateUrl: './language-selection-dialog.component.html',
  styleUrl: './language-selection-dialog.component.scss'
})
export class LanguageSelectionDialogComponent {
  languageFormControl: FormControl<TDBObject> = new FormControl<TDBObject>(null);
  languages: ISelectFormOption[];
  title: string;
  description: string;
  confirmText: string;
  cancelText: string;
  languageSignal: Signal<TDBObject> = toSignal<TDBObject>(this.languageFormControl.valueChanges);

  constructor(
    public dialogRef: MatDialogRef<LanguageSelectionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: LanguageSelectionDialogComponent,
    ) {}

  onConfirm(): void {
    this.dialogRef.close(this.languageSignal());
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }
}
